// extracted by mini-css-extract-plugin
export var almostBlack = "#333";
export var almostWhite = "#f0f0f0";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var card = "index-module--card--vG4kN";
export var cardTitle = "index-module--cardTitle--2pgFN";
export var cardsPerRow3 = "index-module--cardsPerRow3--eJ90F";
export var cardsPerRow4 = "index-module--cardsPerRow4--o6GHI";
export var cardsPerRow5 = "index-module--cardsPerRow5--Umzpg";
export var cardsPerRow6 = "index-module--cardsPerRow6--zM7T7";
export var container = "index-module--container--96YSF";
export var content = "index-module--content--gf462";
export var contentContainer = "index-module--contentContainer--rcx4r";
export var coolGrey = "#e1e2e0";
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var darkGrey = "#4b4d4b";
export var error = "#f66a83";
export var green = "#3dae2b";
export var grey = "#828382";
export var imageCardContainer = "index-module--imageCardContainer--xLsK6";
export var imageCardWrapper = "index-module--imageCardWrapper--fyqDB";
export var lightGreen = "#93d500";
export var lightGrey = "#aba9a9";
export var link = "index-module--link--yKp36";
export var linkIcon = "index-module--linkIcon--c9yfg";
export var moduleRoot = "index-module--moduleRoot--5RkGE";
export var orange = "#fc9948";
export var paleBlue = "#64a1bb";
export var paragraph = "index-module--paragraph--oO4oo";
export var success = "#1ebc7b";
export var titleBar = "index-module--titleBar--qGWgk";
export var warning = "#ffeda0";
export var white = "#fff";
export var yellow = "#fbc900";